import React from "react";
import { useConfig } from "@/hooks/useConfig";
import { imageUrl } from "@/lib/api";

/**
 * Hero visual: van photo. Uses config.heroImage if set (uploaded via admin),
 * otherwise falls back to the bundled /images/anypaku-van.png.
 */
const HeroVan = ({ width = 720, className = "" }) => {
  const config = useConfig();
  const src = imageUrl(config.heroImage) || "/images/anypaku-van.png";
  return (
    <div
      className={className}
      style={{ width: "100%", maxWidth: width, position: "relative" }}
    >
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: "-8% -4% -4% -4%",
          background:
            "radial-gradient(60% 50% at 50% 50%, rgba(245,130,32,0.18), transparent 70%), radial-gradient(45% 40% at 30% 60%, rgba(26,75,140,0.18), transparent 70%)",
          filter: "blur(20px)",
          zIndex: 0,
        }}
      />
      <img
        src={src}
        alt="Anypaku — pakettiauto kuljettajalla, hinta alkaen 40 €"
        style={{
          position: "relative",
          width: "100%",
          height: "auto",
          display: "block",
          objectFit: "contain",
          filter: "drop-shadow(0 30px 40px rgba(15, 36, 64, 0.18))",
          zIndex: 1,
        }}
        data-testid="hero-van-image"
      />
    </div>
  );
};

export default HeroVan;
